import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=ced114e0&scoped=true&"
import script from "./orderDetails.vue?vue&type=script&lang=js&"
export * from "./orderDetails.vue?vue&type=script&lang=js&"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=ced114e0&prod&lang=scss&scoped=true&"
import style1 from "./orderDetails.vue?vue&type=style&index=1&id=ced114e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced114e0",
  null
  
)

export default component.exports